
import { Vue, Component, Prop } from 'vue-property-decorator'
import axios from 'axios'
import Layout from '@/types/layout'
import { notification } from 'ant-design-vue'
import Column from '@/types/column'

@Component({
  components: {}
})

export default class CopyLayoutBudgets extends Vue {
  @Prop() selectedLayoutIds!:number[]
  @Prop() selectedLayouts!:Layout[]

  loading = { layouts: false, budgets: false }
  saving = false

  showModal = false
  searchTimer = 0
  layouts:{ id:number, name:string, external_ref:string }[] = []
  fromLayoutId = null
  budgets:{ id:number }[] = []
  selectedBudgetIds:number[] = []

  columns:Column[] = [
    {
      title: 'Bewakingscode',
      key: 'guard_code',
      scopedSlots: { customRender: 'guard_code' }
    },
    {
      title: 'Omschrijving',
      key: 'description',
      scopedSlots: { customRender: 'description' }
    },
    {
      title: 'Aantal',
      key: 'qty',
      dataIndex: 'qty'
    },
    {
      title: 'Eenheid',
      key: 'unit',
      dataIndex: 'unit'
    },
    {
      title: 'Eenheidsprijs',
      key: 'unit_price',
      scopedSlots: { customRender: 'unit_price' }
    },
    {
      title: 'Totaalprijs',
      key: 'total_price',
      scopedSlots: { customRender: 'total_price' }
    }
  ]

  toggleModal (): void {
    this.showModal = !this.showModal
    this.fromLayoutId = null
    this.budgets = []
  }

  getLayouts (searchTerm:string) : void {
    clearTimeout(this.searchTimer)

    this.searchTimer = setTimeout(() => {
      this.loading.layouts = true

      axios.get(process.env.VUE_APP_API_URL + '/layouts?filter[search]=' + searchTerm + '&limit=250').then((r) => {
        this.layouts = r.data.data
      }).finally(() => {
        this.loading.layouts = false
      })
    }, 500)
  }

  getBudgets (layoutId:number) : void {
    this.loading.budgets = true

    axios.get(process.env.VUE_APP_API_URL + '/layoutBudgets?filter[layout.id]=' + layoutId + '&limit=250').then((r) => {
      this.budgets = r.data.data
      this.selectedBudgetIds = this.budgets.map((budget: { id: number }) => budget.id)
    }).finally(() => {
      this.loading.budgets = false
    })
  }

  onRowClick (rowData:{ id:number }) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          this.selectedBudgetIds.includes(rowData.id) ? this.selectedBudgetIds.splice(this.selectedBudgetIds.indexOf(rowData.id), 1) : this.selectedBudgetIds.push(rowData.id)
        }
      }
    }
  }

  onSelectChange (selectedRowKeys:number[]) : void {
    this.selectedBudgetIds = selectedRowKeys
  }

  copyBudgets (): void {
    const { fromLayoutId, selectedBudgetIds } = this

    if (fromLayoutId && this.selectedLayoutIds.length && selectedBudgetIds.length) {
      this.saving = true
      axios.post(process.env.VUE_APP_API_URL + '/layoutBudgets/copy', { fromLayoutId: fromLayoutId, toLayoutIds: this.selectedLayoutIds, budgetIds: selectedBudgetIds }).then(() => {
        this.$emit('budgetsCopied')
        this.toggleModal()
        notification.success({ message: 'Budgetten gekopieerd.', description: 'De budgetten zijn succesvol gekopieerd.', duration: 3 })
      }).catch(() => {
        notification.error({ message: 'Fout tijdens het kopiëren van budgetten.', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 0 })
      }).finally(() => {
        this.saving = false
      })
    }
  }

  get fromLayout () : string|null {
    const layout = this.layouts.find(opt => opt.id === this.fromLayoutId)
    return layout ? layout.external_ref + ' - ' + layout.name : null
  }
}
